import { render, staticRenderFns } from "./List.vue?vue&type=template&id=23867602&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "@/components/customers/styles/list.scss?vue&type=style&index=0&id=23867602&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23867602",
  null
  
)

export default component.exports